import {SET_LANG_DATA} from '../types/LangTypes';

export const setLang = (lang) => ({
		type: SET_LANG_DATA,
		lang,
	});